<div mat-dialog-title class="title">
  <span class="dialog-title-text">E-Signature</span>
</div>
<mat-dialog-content style="color: black !important;">
    <div style="margin-top:25px;" [innerHTML]="disputeSignPopUpHeaderHtmlContent"></div>
    <div *ngIf="!showImage" class="mt-5">
        <button class="btnAddSign" style="padding: 5px 15px;" 
        (click)="addSignBtnClick()">Add Signature</button>
    </div>

    <div *ngIf="showImage && imageSrc != null">
      <div class="d-flex" style="flex-direction: row;">
        <img src="{{imageSrc}}" style="height:150px;width:300px" alt="E-Signature" />
      </div>    
    </div>  
    <div *ngIf="showUserNameAsSign"><span>{{selectedUser}}</span></div>
    <div class="row ml-2 mt-2" *ngIf="showImage">
      <button class="btnAddSign" (click)="clearAndSignAgain()">Clear And Sign Again</button>
    </div>  
    <div *ngIf="userRoleDesc && userRoleDesc.toLowerCase()=='group admin'"
      style="text-align: center;overflow:visible;margin-left: -400px;">
      <span>Signed By: {{selectedUser}}</span>&nbsp;
      <span>Signed Role: {{userSignRole}}</span>&nbsp;
      <span>Signed Date: {{formattedEsignDate}}</span>
    </div>  
</mat-dialog-content>
<mat-dialog-actions align="end">
  <hr class="separator">
  <div class="d-flex justify-content-center align-items-center" style="margin-right: 1.5rem;">
    <button mat-button class="btn-style btnWidth-small" 
    [disabled]="signresp== null || signresp.signatureData == null || signresp.signatureData.length === 0" 
    [ngClass]="{'disable-btn' : (signresp== null || signresp.signatureData == null || signresp.signatureData.length === 0)}"
    (click)="ok()">Submit</button>
    <button mat-button class="btn-style btnWidth-small" (click)="close()">Close</button>
  </div>
</mat-dialog-actions>







<app-modal *ngIf="showSignPopup" [modalSize]="modalSize" [modalText]="modalText" (modalClose)="closeSignPopup()">
  <div class="signature-popup-content">
    <div class="signature-subtitle">Confirm your name and your signature</div>
    <div class="signature-form-row">
      <div class="w-100">
        <label class="field-label">Printed/Typed Name:<span class="required-star">*</span> </label>
        <div class="field-input" style="background-color: #f5f5f5; color: #666; cursor: not-allowed; padding: 8px;">{{selectedUser}}</div>

        <label class="field-label">Role/title:<span class="required-star">*</span></label>
        <input type="text" class="field-input" placeholder="Enter your Role" [(ngModel)]="userSignRole" required/>

        <label class="field-label">Date Attestation Completed:<span class="required-star">*</span></label>
        <div class="field-input" style="background-color: #f5f5f5; color: #666; cursor: not-allowed; padding: 8px;">{{formattedEsignDate}}</div>
      </div>   
      <div class="w-100">
        <label class="field-label ml-2">Allowed Signature Types<span class="required-star">*</span></label>
        <div class="checkbox-wrapper" *ngIf="isESignAllowed">
          <mat-checkbox class="pt-2" (change)="drawSelect($event)" [(ngModel)]="OptionSelectedToDrawSign">
            Draw signature
          </mat-checkbox>
        </div>
        <div class="checkbox-wrapper" *ngIf="isSSignAllowed">
          <mat-checkbox class="pt-2" (change)="textSelect($event)" [(ngModel)]="OptionSelectedToTypeSign">
            Use /s/ signature
          </mat-checkbox>
        </div>
      </div>
    </div> 
    <!-- Draw signature in canvas -->
    <div [hidden]="!OptionSelectedToDrawSign" class="signature-canvas-section">
      <div class="canvas-header">
        <span class="canvas-title">DRAW YOUR SIGNATURE</span>
        <div class="canvas-actions">
          <button class="canvas-action-btn clear" (click)="clearSign()">Clear</button>
        </div>
      </div>
      <div class="canvas-container">
        <div class="canvas-drawing-area">
          <signature-pad class="signature-pad" (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()" [options]="signaturePadOptions"></signature-pad>
        </div>
      </div>
    </div>
   
    <!-- Text-based signature canvas (only shown when NOT in draw mode) -->
    <div [hidden]="!OptionSelectedToTypeSign" class="text-signature-section">
      <div class="canvas-header">
        <span class="canvas-title">Display /s/ signature</span>
      </div>
      <div class="canvas-container s-signature">
        <div class="canvas-text-area">
          <canvas #canvasEl width="300" height="70"></canvas>
        </div>
      </div>
    </div>
    <div class="mt-2 errormsg m-0 p-0" *ngIf="OptionSelectedToTypeSign">
      Edit the Printed/Typed Name above to modify the /s/ signature
    </div>

   

    <div class="popup-actions mb-4 pb-4">
      <button type="submit" class="action-btn primary" 
      [disabled]="!selectedUser || !userSignRole || !esignDate || (!OptionSelectedToDrawSign && !OptionSelectedToTypeSign)
      || (OptionSelectedToDrawSign && (signaturePad?.isEmpty() ?? true)) || (OptionSelectedToTypeSign && !selectedUser)"
       (click)="submitSign()"> SIGN AND FINALIZE </button>
      <button class="action-btn secondary" (click)="closeSignPopup()">CANCEL</button>
    </div>
  </div>
</app-modal>